export const SCHOOL_JOKES = [
  {
    title: 'Die Fee',
    text: 'Eine Fee erscheint einer Lehrerin und sagt: „Du hast einen Wunsch frei.“ Die Lehrerin überlegt kurz und antwortet: „Ich wünsche mir, dass alle Kinder, die ich unterrichte, richtig schlau werden.“ Die Fee zögert: „Das ist wirklich schwierig. Hättest du vielleicht noch einen anderen Wunsch?“ „Na gut“, sagt die Lehrerin. „Dann wünsche ich mir, dass der Schulkopierer für immer problemlos funktioniert.“ Die Fee überlegt einen Moment und fragt: „Sollen die Kinder später lieber in Harvard oder in Oxford studieren?“'
  },
  {
    title: 'Rundumblick',
    text: 'Ein Schüler fragt: „Frau Müller, haben Lehrerinnen eigentlich Augen im Hinterkopf?“ Sie lächelt: „Nein. Aber Berufserfahrung funktioniert fast genauso gut.“'
  },
  {
    title: 'Die erste Lösung',
    text: 'Der Lehrer fragt: „Wer kennt die Antwort?“ Ein Schüler ruft: „Sie!“ Der Lehrer nickt: „Sehr gut. Die erste richtige Antwort haben wir schon.“'
  },
  {
    title: 'Das geduldige Smartboard',
    text: '„Herr Schneider, warum hören Sie so geduldig zu, wenn das Smartboard nicht funktioniert?“ „Weil Technik und Schüler eines gemeinsam haben: Mit Ruhe zeigen beide, was in ihnen steckt.“'
  },
  {
    title: 'Die schnellste Schulstunde',
    text: 'Ein Schüler sagt: „Die Stunde ist heute richtig schnell vergangen.“ Die Lehrerin antwortet: „Dann waren wir wohl gemeinsam schneller als die Uhr.“'
  },
  {
    title: 'Die schwierigste Rechenaufgabe',
    text: '„Was ist die schwierigste Rechenaufgabe für Lehrer?“ „Aus fünf Minuten Pause gleichzeitig einen Kaffee, eine Kopie und Erholung zu machen.“'
  },
  {
    title: 'Der Globus',
    text: 'Ein Schüler fragt: „Warum sieht der Globus so müde aus?“ Die Lehrerin: „Kein Wunder – wir schicken ihn jeden Tag einmal um die ganze Welt.“'
  },
  {
    title: 'Die Lehrerkraft',
    text: '„Warum heißt es eigentlich Lehrkraft?“ „Weil man mit Wissen, Geduld und Humor erstaunlich viel bewegen kann.“'
  },
  {
    title: 'Überraschungswissen',
    text: 'Ein Schüler fragt: „Müssen wir das wirklich wissen?“ Der Lehrer antwortet: „Nein. Aber wenn du es weißt, kann dich das Leben damit nicht mehr überraschen.“'
  },
  {
    title: 'Der Stundenplan',
    text: '„Frau Wagner, wie behalten Sie den ganzen Stundenplan im Kopf?“ „Ganz einfach: Mein Kopf hat mehr Fächer als die Schule.“'
  },
  {
    title: 'Das Geheimnis der Ruhe',
    text: 'Der Schulleiter fragt einen Lehrer: „Wie schaffen Sie es, dass Ihre Klasse so aufmerksam ist?“ „Ich erzähle so spannend, dass sogar die Uhr das Ticken vergisst.“'
  },
  {
    title: 'Lehrer-Kaffee',
    text: '„Warum trinken Lehrer morgens Kaffee?“ „Damit die guten Ideen noch vor der ersten Stunde wach sind.“'
  },
  {
    title: 'Die Hausaufgabe',
    text: 'Ein Schüler fragt: „Können Hausaufgaben eigentlich glücklich machen?“ Die Lehrerin: „Natürlich – besonders in dem Moment, in dem man merkt, dass man sie verstanden hat.“'
  },
  {
    title: 'Der Rotstift',
    text: '„Warum ist der Rotstift der mutigste Stift im Mäppchen?“ „Weil er sich traut, überall Verbesserungspotenzial zu entdecken.“'
  },
  {
    title: 'Der Taschenrechner',
    text: 'Der Taschenrechner sagt zum Mathematiklehrer: „Ohne mich wären Sie aufgeschmissen!“ Der Lehrer lächelt: „Und wer erklärt dir, welche Tasten du drücken musst?“'
  },
  {
    title: 'Die beste Verbindung',
    text: '„Was ist die schnellste Verbindung zwischen zwei Köpfen?“ „Eine gute Erklärung.“'
  },
  {
    title: 'Lehrerkonferenz',
    text: '„Warum dauern Lehrerkonferenzen manchmal etwas länger?“ „Weil gute Ideen nicht einfach klingeln, wenn die Stunde vorbei ist.“'
  },
  {
    title: 'Das Klassenbuch',
    text: 'Ein Schüler fragt: „Warum wissen Sie immer, was gestern passiert ist?“ Der Lehrer zeigt auf das Klassenbuch: „Ich arbeite mit einem analogen Gedächtnis-Backup.“'
  },
  {
    title: 'Der Montagmorgen',
    text: '„Was sagt eine motivierte Lehrerin am Montagmorgen?“ „Schön, dass ihr alle da seid – dann kann die Woche ja etwas werden!“'
  },
  {
    title: 'Die Kreide',
    text: 'Die Kreide fragt die Lehrerin: „Warum werde ich immer kleiner?“ „Weil du jeden Tag Wissen hinterlässt.“'
  },
  {
    title: 'Die schwierige Frage',
    text: 'Ein Schüler sagt: „Meine Frage ist vielleicht ein bisschen schwierig.“ Der Lehrer antwortet: „Perfekt. An leichten Fragen wächst schließlich niemand.“'
  },
  {
    title: 'Die Pausenklingel',
    text: '„Warum freut sich die Pausenklingel auf den Unterricht?“ „Weil sie nur dank der Lehrkräfte weiß, wann sie ihren großen Auftritt hat.“'
  },
  {
    title: 'Der vergessene Name',
    text: 'Ein Schüler fragt: „Wie können Sie sich so viele Namen merken?“ Die Lehrerin: „Namen merke ich mir schnell. Bei nicht gemachten Hausaufgaben hilft mir allerdings mein Elefantengedächtnis.“'
  },
  {
    title: 'Die Wettervorhersage',
    text: '„Herr Becker, können Lehrer das Wetter vorhersagen?“ „Natürlich: Wenn alle Hausaufgaben haben, wird es eine ausgesprochen heitere Stunde.“'
  },
  {
    title: 'Der volle Schreibtisch',
    text: '„Warum liegt auf dem Lehrerschreibtisch so viel Papier?“ „Weil gute Bildung manchmal eine überraschend große Verpackung hat.“'
  },
  {
    title: 'Die Tafel',
    text: 'Ein Schüler fragt: „Warum schreiben Sie alles an die Tafel?“ Die Lehrerin antwortet: „Damit ihr sehen könnt, wie Gedanken eine lesbare Form bekommen.“'
  },
  {
    title: 'Das Lob',
    text: '„Frau Schmidt, warum loben Sie uns so oft?“ „Weil gute Leistungen wachsen, wenn man sie nicht übersieht.“'
  },
  {
    title: 'Der Stundenbeginn',
    text: 'Der Lehrer sagt: „Heute entdecken wir etwas Neues.“ Ein Schüler fragt: „Und wenn wir es nicht sofort verstehen?“ „Dann entdecken wir es eben zweimal.“'
  },
  {
    title: 'Die Klassenarbeit',
    text: '„Warum bleibt die Lehrerin bei der Klassenarbeit so entspannt?“ „Weil sie weiß: Eine Aufgabe prüft Wissen – aber sie bestimmt niemals den Wert eines Menschen.“'
  },
  {
    title: 'Der Lehrer im Internet',
    text: '„Herr Meier, wissen Sie wirklich alles?“ „Nein. Aber ich weiß, wie man gute Fragen stellt – und das ist oft der schnellste Weg zur Antwort.“'
  },
  {
    title: 'Der schönste Beruf',
    text: 'Ein Kind fragt: „Was ist das Schönste am Lehrerberuf?“ Die Lehrerin antwortet: „Jeden Morgen kommen viele Möglichkeiten durch dieselbe Tür.“'
  }
];